export default {
	getByUserId(id, cb) {
		this.http.get(`/promoter/getByUserId/${id}`, {}).then((response) => {
			cb(response)
		})
	},
	getById(id, cb) {
		this.http.get(`/promoter/getById/${id}`, {}).then((response) => {
			cb(response)
		})
	},
	getCommissionLog(id, params, cb) {
		this.http
			.get(`/promoter/getCommissionLog/${id}`, params)
			.then((response) => {
				cb(response)
			})
	},
	getPromotions(id, params, cb) {
		this.http
			.get(`/promoter/getPromotions/${id}`, params)
			.then((r) => cb && cb(r))
	}
}
